import { memo } from 'react'
import Head from 'next/head'

import useNoTranslate from '~/hooks/useNoTranslate'
import { useUrl } from '~/hooks/useUrl'

import userConfig from '~/config/app'

const AppHead = (): React.ReactElement => {
  const canonicalHref = useUrl()
  const noTranslate = useNoTranslate()

  return (
    <Head>
      {canonicalHref && <link href={canonicalHref} key="canonical" rel="canonical" />}
      <meta
        content={`width=device-width, initial-scale=1${userConfig.isMobileApp ? ',maximum-scale=1' : ''}`}
        name="viewport"
      />
      {noTranslate && <meta content="notranslate" name="google" />}
    </Head>
  )
}

export default memo(AppHead)
